module.exports = __webpack_public_path__ + "img/submit-button.871223a6.png";